import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-合同列表",
  "use": "icon-合同列表-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-合同列表\">\n<g>\n\t<g>\n\t\t<path d=\"M9.9,7.6H5.7c-0.2,0-0.3-0.1-0.3-0.3v0C5.4,7.1,5.5,7,5.7,7h4.2c0.2,0,0.3,0.1,0.3,0.3v0C10.2,7.4,10,7.6,9.9,7.6z\" />\n\t</g>\n</g>\n<g>\n\t<g>\n\t\t<path d=\"M9.9,10H5.8c-0.2,0-0.3-0.1-0.3-0.3v0c0-0.2,0.1-0.3,0.3-0.3h4.2c0.2,0,0.3,0.1,0.3,0.3v0C10.2,9.8,10.1,10,9.9,10z\" />\n\t</g>\n</g>\n<g>\n\t<path d=\"M10.4,13.5h-5c-0.7,0-1.2-0.5-1.2-1.2V5.5c0-0.7,0.5-1.2,1.2-1.2h5c0.7,0,1.2,0.5,1.2,1.2v6.9C11.6,13,11.1,13.5,10.4,13.5\n\t\tz M5.4,5C5.1,5,4.9,5.2,4.9,5.5v6.9c0,0.3,0.2,0.5,0.5,0.5h5c0.3,0,0.5-0.2,0.5-0.5V5.5c0-0.3-0.2-0.5-0.5-0.5H5.4z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/合同列表.svg
// module id = nTTO
// module chunks = 166